import { ObjetKStatusCode } from '@siclop/kstone-vue'

export class ActivityType extends ObjetKStatusCode {
  color: string = '#3498db'
  coefficient: number = 1.0
  description: string = ''
  estimationScaleId?: number
  estimationScaleLabel?: string

  constructor(data?: Partial<ActivityType>) {
    super(data)
    if (data) {
      this.color = data.color ?? '#3498db'
      this.coefficient = data.coefficient ?? 1.0
      this.description = data.description ?? ''
      this.estimationScaleId = data.estimationScaleId
      this.estimationScaleLabel = data.estimationScaleLabel
    }
  }
}
